/* Luvlyn · veelgestelde vragen (/pages/veelgestelde-vragen; ontwerp: veelgestelde-vragen.html en js/vragen.js).
   Alleen wat deze pagina extra doet. Een vraag uit een link openen en oplichten (data-vraag-id) doet
   assets/site.js.
   1. Naar een onderwerp springen: #groep-batterijen scrolt naar die groep.
   2. Een link naar een vraag (#batterijen-hoe-lang) werkt ook als je er twee keer op tikt.
   3. De paginakop: zoeken met suggesties terwijl je typt (ook met de pijltjes, Enter en Escape).
   Alle vragen en antwoorden staan in de HTML; dit script zoekt, opent en markeert alleen. De teksten van
   het zoeken staan als data-attributen in sections/luvlyn-vv-intro.liquid. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const zacht = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // zoeken zonder accenten: "een" vindt ook "één"
  const norm = s => s.toLowerCase().normalize('NFD').replace(/\p{M}/gu, '');
  const woordenVan = q => norm(q).split(/[\s,.?!]+/).filter(w => w.length > 1);
  const esc = s => s.replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const regEsc = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const markeer = (tekst, woorden) => {
    if (!woorden.length) return esc(tekst);
    return esc(tekst).replace(new RegExp(`(${woorden.map(regEsc).join('|')})`, 'ig'), '<mark>$1</mark>');
  };
  const vragen = $('.sectie[data-id="vragen"]');

  /* ---------- 1. naar een onderwerp ---------- */
  function naarGroep(g){
    const doel = vragen && $(`[data-groep="${CSS.escape(g)}"]`, vragen);
    // 'instant' en niet 'auto': html heeft scroll-behavior:smooth, en 'auto' volgt dat
    if (doel) doel.scrollIntoView({ block: 'start', behavior: zacht ? 'instant' : 'smooth' });
  }

  /* ---------- 2. een vraag via een link ---------- */
  const IDS = new Set($$('.vv-vraag[data-vraag-id]').map(x => x.dataset.vraagId));
  function naarVraag(id){
    // dezelfde link nog eens: de hash verandert niet, dus zelf het seintje geven (assets/site.js luistert)
    if (decodeURIComponent(location.hash.slice(1)) === id) dispatchEvent(new HashChangeEvent('hashchange'));
    else location.hash = id;
  }
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]'); if (!a) return;
    const id = decodeURIComponent(a.getAttribute('href').slice(1));
    if (!IDS.has(id)) return;
    e.preventDefault();
    naarVraag(id);
  });
  addEventListener('hashchange', () => {
    const id = decodeURIComponent(location.hash.slice(1));
    if (id.startsWith('groep-')) naarGroep(id.slice(6));
  });
  requestAnimationFrame(() => {
    const id = decodeURIComponent(location.hash.slice(1));
    if (id.startsWith('groep-')) naarGroep(id.slice(6));
  });

  /* ---------- 3. de paginakop: zoeken met suggesties ---------- */
  const INDEX = [];
  $$('.vv-vraag[data-vraag-id]').forEach(el => {
    const id = el.dataset.vraagId;
    if (INDEX.some(x => x.id === id)) return;
    const vraag = $('h3', el).textContent.trim(), antwoord = $('.vv-antwoord', el).textContent.trim();
    // het antwoord gaat mee als kleine regel eronder (de CSS kort hem af op twee regels)
    INDEX.push({ id, vraag, kort: antwoord, inVraag: norm(vraag), inAlles: norm(`${vraag} ${antwoord}`) });
  });
  $$('[data-vv-suggestie]').forEach(box => {
    const invoer = $('[data-vv-invoer]', box), lijst = $('[data-vv-lijst]', box), status = $('[data-vv-status]', box);
    const T = box.dataset;
    const dicht = () => { lijst.hidden = true; };
    function toon(){
      const w = woordenVan(invoer.value);
      if (!w.length) { dicht(); status.textContent = ''; return; }
      const hits = INDEX.filter(x => w.every(y => x.inAlles.includes(y)))
        .sort((a, b) => w.filter(y => b.inVraag.includes(y)).length - w.filter(y => a.inVraag.includes(y)).length)
        .slice(0, 6);
      lijst.innerHTML = hits.length
        ? hits.map(x => `<li><a href="#${x.id}"><b>${markeer(x.vraag, w)}</b><small>${esc(x.kort)}</small></a></li>`).join('')
        : `<li class="vv2-niets">${esc(T.niets || '')}</li>`;
      lijst.hidden = false;
      status.textContent = hits.length ? (hits.length === 1 ? T.een : (T.meer || '').replace('[n]', hits.length)) : T.geen;
    }
    invoer.addEventListener('input', toon);
    invoer.addEventListener('focus', toon);
    invoer.addEventListener('keydown', e => {
      const eerste = !lijst.hidden && $('a', lijst);
      if (e.key === 'ArrowDown' && eerste) { e.preventDefault(); eerste.focus(); }
      if (e.key === 'Enter' && eerste) { e.preventDefault(); eerste.click(); }
      if (e.key === 'Escape') dicht();
    });
    lijst.addEventListener('keydown', e => {
      const links = $$('a', lijst), i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); links[Math.min(i + 1, links.length - 1)].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) invoer.focus(); else links[i - 1].focus(); }
      if (e.key === 'Escape') { dicht(); invoer.focus(); }
    });
    // eerst dicht, daarna doet de klik op document (2.) de rest
    lijst.addEventListener('click', e => { if (e.target.closest('a')) dicht(); });
    document.addEventListener('click', e => { if (!box.contains(e.target)) dicht(); });
    box.addEventListener('focusout', e => { if (!box.contains(e.relatedTarget)) dicht(); });
  });
})();
